import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiQuizEditComponent } from './fi-quiz-edit.component';
import { FiAccessRightFiltersModule } from '@fi-shared/access-right-filters';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiSimpleContenteditableModule } from '@fi-shared/fi-simple-contenteditable/fi-simple-contenteditable.module';
import { FormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { SideListModule } from '@fi-app/utilities/side-list/side-list.module';
import { FiValidatingFormModule } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.module';
import { FiEditorPageHeaderModule } from '@fi-app/shared/fi-editor-page-header/fi-editor-page-header.module';
import { MatTabsModule } from '@angular/material/tabs';
import { FiQuizEditorTabComponent } from './quiz-editor-tab/quiz-editor-tab.component';
import { FiQuizEditorStoreService } from './fi-quiz-editor-store.service';
import { FiTwoColumnsContainerModule } from '@fi-app/shared/fi-two-columns-container/fi-two-columns-container.module';
import { FiTranslationRadioGroupModule } from '@fi-shared/fi-translation-radio-group/fi-translation-radio-group.module';
import { MatCardModule } from '@angular/material/card';
import { FiNameDescriptionInputModule } from '@fi-app/shared/name-description-input/name-description-input.module';
import { FiQuizQuestionCardsListComponent } from './quiz-editor-tab/quiz-question-cards-list/quiz-question-cards-list.component';
import { MatIconModule } from '@angular/material/icon';
import { CdkDropList, CdkDrag, CdkDragHandle, CdkDragPlaceholder, CdkDragPreview } from '@angular/cdk/drag-drop';
import { FiQuizAddedQuestionsListComponent } from './quiz-editor-tab/quiz-added-questions-list/quiz-added-questions-list.component';
import { FiQuizQuestionCardComponent } from './quiz-editor-tab/quiz-added-questions-list/quiz-question-card/quiz-question-card.component';
import { MatInputModule } from '@angular/material/input';
import { FiQuizNameDescriptionCardComponent } from './quiz-editor-tab/quiz-name-description-card/quiz-name-description-card.component';
import { FiQuizTranslationCardComponent } from './quiz-editor-tab/quiz-translation-card/quiz-translation-card.component';
import { FiMatIconCheckboxMenuModule } from '@fi-shared/fi-mat-icon-checkbox-menu/fi-mat-icon-checkbox-menu.module';
import { FiInfoBannerModule } from '@fi-app/shared/fi-info-banner/fi-info-banner.module';
import { FiAnswerOptionsDndEditorModule } from '@fi-app/shared/fi-answer-options-dnd-editor/fi-answer-options-dnd-editor.module';
import { FiToggleSwitchModule } from '@fi-app/shared/fi-toggle-switch/fi-toggle-switch.module';
import { FiQuizSettingsTabComponent } from './quiz-settings-tab/quiz-settings-tab.component';
import { MatSelectModule } from '@angular/material/select';
import { FiQuizThresholdSettingsComponent } from './quiz-settings-tab/threshold-settings/quiz-threshold-settings.component';
import { FiQuizRetakesSettingsComponent } from './quiz-settings-tab/retakes-settings/quiz-retakes-settings.component';
import { FiQuizNotificationsSettingsComponent } from './quiz-settings-tab/notifications-settings/quiz-notifications-settings.component';
import { FiQuizTimerSettingsComponent } from './quiz-settings-tab/timer-settings/quiz-timer-settings.component';
import { FiQuizNotificationDialogComponent } from './quiz-settings-tab/notifications-settings/quiz-notification-dialog/quiz-notification-dialog.component';
import { FiAutomatedActionRecipientSelectModule } from '@fi-app/shared/automated-action-recipient-select/automated-action-recipient-select.module';
import { MatButtonModule } from '@angular/material/button';
import { FiAutomatedActionListItemModule } from '@fi-shared/automated-action-list-item/action-list-item.module';
import { FiQuizSharingSettingsComponent } from './quiz-settings-tab/sharing-settings/quiz-sharing-settings.component';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';
import { FiThreeColumnsContainerModule } from '@fi-app/shared/fi-three-columns-container/fi-three-columns-container.module';
import { FiQuizEditorGuideCardComponent } from './quiz-editor-guide-card/fi-quiz-editor-guide-card.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { FiProgressTimelineModule } from '@fi-app/shared/fi-progress-timeline/fi-progress-timeline.module';
import { FiQuizSettingsSharingGuideCardComponent } from './quiz-settings-sharing-guide-card/fi-quiz-settings-sharing-guide-card.component';
import { FiNameInputModule } from '@fi-shared/fi-name-input/fi-name-input.module';

@NgModule({
    imports: [
        CommonModule,
        FiAccessRightFiltersModule,
        FiAppTextSharedModule,
        FiSimpleContenteditableModule,
        FormsModule,
        MatCheckbox,
        MatRadioButton,
        MatRadioGroup,
        SideListModule,
        FiValidatingFormModule,
        FiEditorPageHeaderModule,
        MatTabsModule,
        FiTwoColumnsContainerModule,
        FiTranslationRadioGroupModule,
        MatCardModule,
        FiNameDescriptionInputModule,
        MatIconModule,
        CdkDropList,
        CdkDrag,
        CdkDragHandle,
        CdkDragPlaceholder,
        CdkDragPreview,
        MatInputModule,
        FiMatIconCheckboxMenuModule,
        FiInfoBannerModule,
        FiAnswerOptionsDndEditorModule,
        FiToggleSwitchModule,
        MatSelectModule,
        FiAutomatedActionRecipientSelectModule,
        MatButtonModule,
        FiAutomatedActionListItemModule,
        InfoIconModule,
        FiThreeColumnsContainerModule,
        MatExpansionModule,
        FiProgressTimelineModule,
        FiNameInputModule,
    ],
    declarations: [
        FiQuizEditComponent,
        FiQuizEditorTabComponent,
        FiQuizQuestionCardsListComponent,
        FiQuizAddedQuestionsListComponent,
        FiQuizQuestionCardComponent,
        FiQuizNameDescriptionCardComponent,
        FiQuizTranslationCardComponent,
        FiQuizSettingsTabComponent,
        FiQuizThresholdSettingsComponent,
        FiQuizRetakesSettingsComponent,
        FiQuizNotificationsSettingsComponent,
        FiQuizTimerSettingsComponent,
        FiQuizNotificationDialogComponent,
        FiQuizSharingSettingsComponent,
        FiQuizEditorGuideCardComponent,
        FiQuizSettingsSharingGuideCardComponent,
    ],
    providers: [FiQuizEditorStoreService],
})
export class FiQuizEditModule {}
